// extracted by mini-css-extract-plugin
module.exports = {"container":"_2dKm7Gg98FR0TVvbq5R4Ix","logo":"_3CCT5PFoMnT-86mnRmImCp"};